module.exports = __webpack_public_path__ + "static/media/img4.4de791d9.jpg";